import { Component, OnInit, ViewChild, OnChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from './../UtilityServices';


@Component({
  selector: 'app-add-updateuser',
  templateUrl: './add-updateuser.component.html',
  styleUrls: ['./add-updateuser.component.scss']
})
export class AddUpdateuserComponent implements OnInit, OnDestroy {
  staffFirstname: any = '';
  staffLastname: any = '';
  staffEmail: any = '';
  isstaffActive: any = false;
  isstaffGroup: any = 0;
  dmessage: any;
  action: any = "Add New";
  constructor(private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    private utility: UtilityServices) {
    this.GetRolesList();
    // setTimeout(() => {
    //   this.loadUpdateUser();
    // }, 500);

  }

  ngOnDestroy() {
    sessionStorage.setItem("updateuser", "");
  }

  loadUpdateUser() {

    let item = sessionStorage.getItem("updateuser");
    // console.log(item);
    if (item && item.length > 0) {
      this.action = "Update";
      let itemUser = JSON.parse(item);
      this.staffEmail = itemUser.Username;
      this.staffFirstname = itemUser.FirstName;
      this.staffLastname = itemUser.LastName;
      this.isstaffGroup = itemUser.RoleName === "Administrator" ? "1" : "2";
      this.isstaffActive = itemUser.Active === "True" ? true : false;
    }
  }

  ngOnInit(): void {
  }

  Userroles: any = [];
  GetRolesList(): void {
    this.httpClient.get(serviceUrl + '/User/GetUserRoles',
      '').toPromise<any>().then(response => {
        this.Userroles = response;
        this.loadUpdateUser();
      });
  }
  message: any;

  SaveUser() {
    if (this.staffLastname && this.staffLastname.length > 0 && this.staffFirstname && this.staffFirstname.length > 0
      && this.staffEmail && this.staffEmail.length > 0 && this.isstaffGroup && this.isstaffGroup > 0) {

      const hdrs = new HttpHeaders(
        { 'Content-type': 'application/json' });
      this.http.post<any>(serviceUrl + '/User/InsertUser', {
        LastName: this.staffLastname,
        FirstName: this.staffFirstname,
        Email: this.staffEmail,
        Username: this.staffEmail,
        RoleId: this.isstaffGroup,
        Active: this.isstaffActive
      }, { headers: hdrs }).subscribe(
        res => {

          //this.meetingid = res;
          this.ClearStaffMember();
          this.message = 'Staff Member Successfully saved.';
        },
        err => {


        });
    } else {
      this.message = 'Please enter required fields.';
    }
  }

  CloseStaffMember() {
    this.router.navigateByUrl('/UserMaintenance');
  }
  ClearStaffMember() {
    this.staffLastname = '';
    this.staffFirstname = '';
    this.staffEmail = '';
    this.isstaffGroup = 0;
    this.isstaffActive = false;
  }
}
